import { CommentType } from 'types/postTypes';

function changeCounter(counter: number, action: 'inc' | 'dec') {
  const result = action === 'inc' ? counter + 1 : counter - 1;
  return result || 0;
}

export function updateComments(comments: CommentType[], commentId: string): CommentType[] {
  return comments.map((comment) =>
    comment.id === commentId
      ? ({
          ...comment,
          meta: {
            ...comment.meta,
            reaction_count: changeCounter(comment.meta?.reaction_count || 0, comment.myReaction ? 'dec' : 'inc'),
          },
          myReaction: comment.myReaction ? null : '91:1',
        } as CommentType)
      : comment
  );
}

export function updateCommentCounter(
  comments: CommentType[],
  commentId: string,
  reaction_count: number
): CommentType[] {
  return comments.map((comment) =>
    comment.id === commentId
      ? ({
          ...comment,
          meta: {
            ...comment.meta,
            reaction_count,
          },
        } as CommentType)
      : comment
  );
}
